import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist';
import account from './account';
import app from './app'
import concept from './concept'
import cart from './cart'

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: 'FOODIE',
  storage: localStorage
});
export default new Vuex.Store({
  modules: {
    account,
    app,
    concept,
    cart
  },
  plugins: [vuexPersist.plugin]
});
